import { configuration } from "../../utilities";
export function getClass(className) {
  var nameSpace = configuration.current.styles.namespace;
  var componentClassName = "FlexGrid-".concat(className);

  if (nameSpace) {
    return "".concat(nameSpace, "-").concat(componentClassName);
  }

  return componentClassName;
}
export function createProps(props, classNames) {
  var newProps = {};
  Object.keys(props).filter(function (key) {
    return key === "children";
  }).forEach(function (key) {
    return newProps[key] = props[key];
  });
  var className = classNames.filter(function (cn) {
    return cn;
  }).join(" ");
  return Object.assign({}, newProps, {
    className: className
  });
}
export function getPropsFromAttribute(el) {
  var rawProps = el.getAttribute("data-props");
  return rawProps === null ? {} : JSON.parse(rawProps);
}